import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { GET_SPACELIFT_VCS_REPO_COMMIT } from "./gql";

type UseGetSpaceliftVcsRepoCommitProps = {
  repoId: string;
  sha: string;
};

const useGetSpaceliftVcsRepoCommit = ({ repoId, sha }: UseGetSpaceliftVcsRepoCommitProps) => {
  const { data, loading, error, previousData } = useQuery(GET_SPACELIFT_VCS_REPO_COMMIT, {
    variables: { repoID: repoId, sha },
  });

  const commit = useMemo(() => {
    return data?.repoCommit || previousData?.repoCommit;
  }, [data, previousData]);

  return {
    commit,
    loading,
    error,
  };
};

export default useGetSpaceliftVcsRepoCommit;
